var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" В данный момент настройка, добавление и удаление пользователей находится "),_c('a',{attrs:{"href":"https://admin.alfagrad.net/","target":"_blank"}},[_vm._v("тут")]),_vm._v(". ")])
}]

export { render, staticRenderFns }